import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import DeviceVideo from 'components/DeviceVideo/DeviceVideo';

import { StyledGrid } from './styles/Grid';

function SectionTransfer({ index }) {
  return (
    <Box
      tag="section"
      id="pre-registro"
      paddingVertical={{ xs: '12x', md: '20x', lg: '24x' }}
      paddingHorizontal={{ xs: '4x', md: '8x', lg: '12x' }}
    >
      <Grid
        row
        alignItems="center"
        justify={{ xs: 'center', lg: 'space-around' }}
      >
        <StyledGrid
          col={{ xs: '12', md: '8', lg: '3' }}
          order={{ lg: 2 }}
        >
          <DeviceVideo
            videoId="YnnJHw_qJx4"
            deviceType="dark"
            hasDeviceOnMobile
          />
        </StyledGrid>

        <Grid
          col={{ xs: '12', lg: '5' }}
        >
          <Box
            paddingTop={{ xs: '6x', md: '12x' }}
          >
            <Typography
              variant="title"
              gutterBottom={1.5}
              intlKey={`cms.pixPage.pixCardsArea[${index}].title`}
              intlValues={{ br: <br /> }}
            />

            <Typography
              variant="subtitle"
              intlKey={`cms.pixPage.pixCardsArea[${index}].description`}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

SectionTransfer.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionTransfer);
